import { useRef, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'

import 'swiper/scss'

import map from 'lodash/map'
import uniqBy from 'lodash/uniqBy'
import get from 'lodash/get'
import split from 'lodash/split'
import classNames from 'classnames'

import Image from './basic/image'
import styles from './news_carousel.module.sass'
import BlockWrapper from './layout/block_wrapper'
import Media from './basic/media'
import Title from './basic/title'
import Button from './basic/button'
import Link from './basic/link'
import ScrollAnimation from './layout/scroll_animation'

function NewsCarousel(props) {
	const sliderRef = useRef(null)
	const fields = props.fields
	const [carouselSlides, setCarouselSlides] = useState(null)
	const [carouselItems, setCarouselItems] = useState([])
	const [activeCategory, setActiveCategory] = useState(null)

	const categories = uniqBy(map(uniqBy(fields.items, (item) => item.category), function (item) {
		let i, categories = split(item.category, ',')

		for (i = 0; i < categories.length; i++) {
			return categories[i].trim()
		}
	}))

	const sliderConfig = {
		modules: [Navigation],
		spaceBetween: 20,
		slidesPerView: 2,
		slidesPerGroup: 2,
		loop: false,
		watchSlidesProgress: true,
		navigation: {
			prevEl: `.${styles.previous}`,
			nextEl: `.${styles.next}`,
			clickable: true
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 10
			},
			900: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1240: {
				slidesPerView: 2,
				spaceBetween: 20
			},
		}
	}

	const handleMouseEvent = (index) => {
		setCarouselItems(
			carouselItems.map(
				(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, buttonActive: false }
			)
		)
	}

	useEffect(() => {
		setCarouselSlides([...get(sliderRef, 'current.swiper.slides', [])])
	}, [])

	useEffect(() => {
		if(sliderRef.current && carouselSlides){
			let slider = sliderRef.current.swiper
			let filteredSlides = activeCategory ? carouselSlides.filter((slide) => slide.getAttribute('data-category').indexOf(activeCategory) > -1) : carouselSlides

			slider.slides.forEach((slide) => slide.remove())

			filteredSlides.forEach((slide) => {
				slider.el.childNodes[0].appendChild(slide)
			})

			slider.update()
		}
	}, [activeCategory])

	useEffect(() => {
		async function fetchData() {
			const response = await fetch(`/wp-json/3fo-base/v1/news/`, {
				cache: 'no-cache',
				headers: {
					'Content-Type': 'application/json'
				},
			})

			const responseJson = await response.json()
			console.log(responseJson.body_response)

			if(responseJson.body_response[0].length > 0){
				const decorateCarouselItems = responseJson.body_response[0].map(obj => ({ ...obj, buttonColor: 'green', buttonActive: false }))
				// const decorateCarouselItems = fields.items.map(obj => ({ ...obj, buttonColor: 'white', buttonActive: false }))
				setCarouselItems(decorateCarouselItems)
			}
		}

		fetchData()

		function onResize() {
			if (window.innerWidth < 768 && carouselItems.length <=3 ) {
				sliderRef.current.swiper.disable()
			}
		}

		window.addEventListener('resize', onResize)

		onResize()

		return () => window.removeEventListener('resize', onResize)
	}, [])

	const buttonColors = {
		default: 'green',
		purple: 'purple',
	}

	return <BlockWrapper {...props} className={styles.news_carousel}>
		<ScrollAnimation styles={styles}>
			{categories.length > 1 && 
				<div className={styles.filter_wrapper}>
					<span className={styles.h3}>Filter By:</span>
					<div className={styles.filter}>
					{categories.map((category, i) => {
						return <button key={i} className={classNames(styles.h3, styles.option, activeCategory == category ? styles.active : '')} onClick={() => setActiveCategory(category)}>{category}</button>
					})}
					</div>
				</div>
			}
			<div className={classNames(styles.carousel_wrapper, carouselItems.length <=3 ? styles.no_arrows : styles.has_arrows)}>
				<button aria-label='previous' className={styles.previous}></button>
				<Swiper ref={sliderRef} className={classNames(props.editor ? styles.in_editor : '', styles.carousel)} {...sliderConfig}>
					{carouselItems && carouselItems.map((item, index) => {
						return <SwiperSlide 
							onMouseEnter={() => handleMouseEvent(index)}
							onMouseLeave={() => handleMouseEvent()}
							className={classNames(styles.carousel_item, item.icon ? styles.with_icon : '')} 
							key={index}
							data-category={item.category}
						>
							<Link href={item.fields.article_url} target={item.fields.open_new_window ? '_blank' : '_self'}>
								<div className={styles.cardContainer}>
									<h3>{item.post_title}</h3>
									{item.excerpt &&
										<div className={styles.content} dangerouslySetInnerHTML={{ __html: `<p>${item.excerpt}</p>`}} />
									}
								</div>
								<Button className={styles.button} color={buttonColors[item.button_color]} active={item.buttonActive}>Read More</Button>
							</Link>
						</SwiperSlide>
						
					})}
				</Swiper>
				<button aria-label='next' className={styles.next}></button>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default NewsCarousel